/** True when the active DPR shift is marked skipped in Redux/header checkboxes. */
export function isDprShiftSkipped(skipDay, skipNight, shift) {
  if (shift === 'day') return Boolean(skipDay);
  if (shift === 'night') return Boolean(skipNight);
  return false;
}

export function getDprShiftLabel(shift) {
  return shift === 'night' ? 'Night' : 'Day';
}
